export class ApiError extends Error {
  constructor(
    message: string,
    public readonly status: number,
    public readonly code?: string
  ) {
    super(message);
  }
}

export async function api<T>(
  path: string,
  init: RequestInit = {},
  signal?: AbortSignal
): Promise<T> {
  const response = await fetch(path, {
    ...init,
    credentials: 'same-origin',
    headers: {
      ...(init.body ? { 'Content-Type': 'application/json' } : {}),
      ...init.headers
    },
    signal
  });
  const body = (await response.json().catch(() => null)) as
    | { error?: { message?: string; code?: string } }
    | null;
  if (!response.ok) {
    throw new ApiError(
      body?.error?.message ?? 'Không thể kết nối tới hệ thống.',
      response.status,
      body?.error?.code
    );
  }
  return body as T;
}

export function queryString(values: Record<string, string | number | undefined>): string {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(values)) {
    if (value !== undefined && value !== '') params.set(key, String(value));
  }
  return params.toString();
}
